import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import MainNavigation from '../../components/ui/MainNavigation';
import Button from '../../components/ui/Button';
import NewsMetrics from './components/NewsMetrics';
import NewsList from './components/NewsList';
import NewsForm from './components/NewsForm';

const ProviderNewsUpdatesCenter = () => {
  const { user, userProfile, loading } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('published');
  const [showForm, setShowForm] = useState(false);
  const [editingArticle, setEditingArticle] = useState(null);

  useEffect(() => {
    if (!loading && (!user || !['provider', 'superadmin']?.includes(userProfile?.user_type))) {
      navigate('/leverancier-login');
    }
  }, [user, userProfile, loading, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Laden...</p>
        </div>
      </div>
    );
  }

  const handleEdit = (article) => {
    setEditingArticle(article);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingArticle(null);
  };

  const tabs = [
    { id: 'published', label: 'Gepubliceerde Artikelen', icon: 'FileCheck' },
    { id: 'draft', label: 'Concepten', icon: 'FileEdit' },
    { id: 'analytics', label: 'Statistieken', icon: 'BarChart3' },
  ];

  return (
    <div className="min-h-screen bg-background">
      <MainNavigation />

      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
        {/* Header */}
        <div className="bg-card border-b border-border shadow-elevation-1 p-4 sm:p-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-heading font-bold text-foreground">Nieuws & Updates Centrum</h1>
              <p className="text-sm text-muted-foreground mt-1">
                Deel bedrijfsnieuws, projectshowcases en branche-inzichten met uw klanten
              </p>
            </div>
            <Button
              onClick={() => setShowForm(true)}
              iconName="Plus"
              iconPosition="left"
            >
              Nieuw Artikel
            </Button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Metrics */}
          <NewsMetrics />

          {/* Tabs */}
          <div className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="border-b border-border">
              <div className="flex space-x-1 p-2">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                      activeTab === tab?.id
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                    }`}
                  >
                    <span>{tab?.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Content Area */}
            <div className="p-6">
              {activeTab === 'analytics' ? (
                <div className="text-center py-12">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted mb-4">
                    <span className="text-3xl">📊</span>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">Statistieken Dashboard</h3>
                  <p className="text-muted-foreground max-w-md mx-auto">
                    Bekijk artikel engagement, lezer demografie en lead generatie attributie
                  </p>
                </div>
              ) : (
                <NewsList
                  status={activeTab}
                  onEdit={handleEdit}
                />
              )}
            </div>
          </div>
        </div>
      </main>

      {/* News Form Modal */}
      {showForm && (
        <NewsForm
          article={editingArticle}
          onClose={handleFormClose}
        />
      )}
    </div>
  );
};

export default ProviderNewsUpdatesCenter;